import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { delay, map, switchMap, tap } from 'rxjs/operators';
import { WorkerService } from 'src/app/data/worker.service';
import { EducationHistoryGridDto } from '../models/dtos/education-history-grid-dto';

interface PagingRequest {
  WorkerId: number;
  Page: number;
  PageSize: number;
  SortingDirection: string;
  SortingField: string;
}

@Injectable({
  providedIn: 'root',
})
export class EducationHistoryDataSource {
  private workerService = inject(WorkerService);

  countSubject = new BehaviorSubject<number>(0);
  count$: Observable<number> = this.countSubject.asObservable();

  educationHistorySubject = new Subject<PagingRequest>();
  educationHistory$: Observable<EducationHistoryGridDto[]> = this.educationHistorySubject.pipe(
    delay(0),
    switchMap((request) =>
      request.WorkerId
        ? this.workerService
          .getWorkerEducationHistory(request.WorkerId, request.Page, request.PageSize, request.SortingField, request.SortingDirection)
          .pipe(
            tap((res) => this.countSubject.next(res.Count)),
            map((res) => res.Results),
          )
        : of([]),
    ),
  );

  constructor() { }
}
